import React from 'react';
import { View, Platform } from 'react-native';
import { IconButton } from '../../IconButton';
import { useStyleSheet } from '../../../hooks';
import { createStyleSheet } from '../../../utils';
import { useAvailabilityEditorContext } from '../hooks';
import { Timeslot } from './Timeslot';
const Interval = ({ style = {}, value, day }) => {
    const styles = useStyleSheet(getStyles);
    const { remove, onTo, onFrom } = useAvailabilityEditorContext();
    return (React.createElement(View, { style: [styles.container, style] },
        React.createElement(Timeslot, { value: value, onPress: onFrom, bound: 'from', day: day }),
        React.createElement(View, { style: styles.hyphen }),
        React.createElement(Timeslot, { value: value, onPress: onTo, bound: 'to', day: day }),
        React.createElement(IconButton, { type: 'tertiary', accent: 'neutral', value: 'delete', onPress: () => {
                remove(day, value);
            }, style: styles.delete, size: 'sm' })));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    // @ts-expect-error react-native does not support string for zIndex
    container: Object.assign({ width: '100%', flexDirection: 'row', alignItems: 'center' }, (Platform.OS === 'web' ? { zIndex: 'unset' } : {})),
    hyphen: {
        marginHorizontal: size.C,
        backgroundColor: color.invert2.p16,
        width: size.A + size.B,
        height: size.A,
        borderRadius: 9999
    },
    delete: {
        marginLeft: size.C
    }
}));
export default Interval;
//# sourceMappingURL=Interval.js.map